import CheckableItem from './checkable_item'

export default CheckableItem
